const resolvablePromise = () => {
  let resolve;
  let reject;
  const promise = new Promise((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });
  (promise as any).resolve = resolve;
  (promise as any).reject = reject;
  return promise;
};

// 默认模板缓存过期时间.
export const DEFAULT_TEMPLATES_EXPIRES = 30 * 60;

const dbName = 'web-components-DB';
const storeName = 'web-components-table';
// 1.新建或者打开数据库
const request = window.indexedDB.open(dbName);
const dbPromise: any = resolvablePromise();
request.onupgradeneeded = () => {
  const db = request.result;
  // 2.创建对象仓库，即新建表
  db.createObjectStore(storeName);
  dbPromise.resolve(db);
};
request.onsuccess = () => {
  const db = request.result;
  dbPromise.resolve(db);
};
const getStore = async (operationMode) => {
  const db = await dbPromise;
  return db.transaction(storeName, operationMode).objectStore(storeName);
};

const promisify = (request, successHandler?, errorHandler?) => {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => {
      if (successHandler) {
        successHandler(request);
      }
      resolve(request.result);
    };
    request.onerror = () => {
      if (errorHandler) {
        errorHandler(request);
      }
      reject(request.error);
    };
  });
};

// 3.添加数据
export const setValue = async (key, value) => {
  const store = await getStore('readwrite');
  const request = store.put(value, key);
  return promisify(request, () => {
    // 更新完成后触发自定义事件
    const event = new CustomEvent('setItemEvent', { detail: { key: key, value } });
    window.dispatchEvent(event);
  });
};
// 4.读取数据
export const getValue = async (key) => {
  const store = await getStore('readonly');
  const request = store.get(key);
  return promisify(request);
};

export const key = 'webComponents';
export const LEFT_FIELDS = 'leftFields';
export const IS_TEMPLATE = 'isTemplate';
export const executionState = 'executionState';
export const HOOK_EXECUTION_STATE = 'hookExecutionState';
export const COMPONENT_CHOSEN = 'componentChosen';
export const DomainModule = 'DomainModule';
export const treeKey = 'treeKey';
export const OPEN_SETTING_DIALOG_VISIBLE = 'openSettingDialogVisible';
export const WEB_COMPONENTS_STATUS = 'webComponentsStatus';
